import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img28 from "../../About/images/28.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person28 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img28} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Снопков Дмитрий Игоревич
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Магистр, младший научный сотрудник
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=59495818600'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0001-6907-9667'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        НАО «Торайгыров Университет», младший научный сотрудник
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание литературного обзора и создание скриптов для экспериментальной части на Python.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Имеет публикации по вопросам экологии и рационального природопользования, является исполнителем программно-целевых проектов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Grant No. AP22787570: «Comprehensive study of identification of soil pollution sources in the cities of Kazakhstan using modern methods of analysis and modeling»
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Grant No. AP23486720: «Comprehensive study of air pollution in cities of Kazakhstan: emissions inventory, source apportionment, and socio-economic impacts»
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований, написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание литературного обзора и создание скриптов для экспериментальной части на Python.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Snopkov, D., Radelyuk, I., Chin, H.H., Tan, R.R., Zhapargazinova, K. A Python-Based Tool for Industrial Water Integration. Chemical Engineering Transactions, 2024, 114, pp. 655–660. DOI: https://doi.org/10.3303/CET24114110
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Radelyuk, I., Snopkov, D., Tan, R.R., Zhapargazinova, K. History of Water Integration in the Oil Refining Industry – A Systematic Review. Chemical Engineering Transactions, 2024, 114, pp. 691–696. DOI: https://doi.org/10.3303/CET24114116
                </MyText>
            </Flex>
        </Flex>
    );
}